sap.ui.define(["sap/ui/core/library", 'sap/uxap/BlockBase'], function (coreLibrary, BlockBase) {
	"use strict";

	var ViewType = coreLibrary.mvc.ViewType;

	var Calendar = BlockBase.extend("com.reply.leaviosa.blocks.calendar.Calendar", {
		metadata: {
			views: {
				Collapsed: {
					viewName: "com.reply.leaviosa.blocks.calendar.Calendar",
					type: ViewType.XML
				},
				Expanded: {
					viewName: "com.reply.leaviosa.blocks.calendar.Calendar",
					type: ViewType.XML
				}
			}
		}
	});
    
	return Calendar;
});